import { LinkProps as NextLinkProps } from 'next/dist/client/link';
import { AnchorHTMLAttributes, PropsWithChildren } from 'react';

import styles from './button.module.css';
import { useBottomNavigation } from '../../../../bottom-navigation.context';

export type ButtonProps = PropsWithChildren<NextLinkProps & Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'target'>>;
export const Button = ({ children, ...props }: ButtonProps) => {
  const { linkFactory } = useBottomNavigation();
  return linkFactory({ ...props, className: styles.button, children });
};
